import { render } from "./AguaView.vue?vue&type=template&id=2cbd5903"
import script from "./AguaView.vue?vue&type=script&lang=js"
export * from "./AguaView.vue?vue&type=script&lang=js"

import "./AguaView.vue?vue&type=style&index=0&id=2cbd5903&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__